require('../../modules/es.set');

require('../../modules/es.object.to-string');

require('../../modules/es.string.iterator');

require('../../modules/web.dom-collections.iterator');

module.exports = require('../../internals/path').Set;